import { Box, Grid, Typography } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';
import { StatementDetailsProps } from 'src/types/commission-statement';
import { formatDate } from 'src/utils/utils';

import { TextDisplay } from '../AddMerchantPage/steps/SummaryInformation/components/InformationSection/components/TextDisplay';

const StatementDetails = ({ statement }: StatementDetailsProps) => {
    return (
        <Grid
            item
            xs={12}
            sx={{
                ...DEFAULT_BORDER,
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                padding: '32px 24px',
            }}
            gap={2}
            container
        >
            {/* Heading */}
            <Grid item xs={12}>
                <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                    <Typography variant="h2">Statement details</Typography>
                </Box>
            </Grid>

            <TextDisplay
                label="Partner"
                value={statement?.partnerName}
                labelTypographyStyles={{
                    marginBottom: '4px',
                }}
                valueTypographyStyles={{
                    fontSize: '14px',
                }}
            />
            <TextDisplay
                label="Statement ID"
                value={statement?.statementId}
                labelTypographyStyles={{
                    marginBottom: '4px',
                }}
                valueTypographyStyles={{
                    fontSize: '14px',
                }}
            />
            <TextDisplay
                label="Statement Date"
                value={formatDate({ date: statement?.statementDate })}
                labelTypographyStyles={{
                    marginBottom: '4px',
                }}
                valueTypographyStyles={{
                    fontSize: '14px',
                }}
            />
        </Grid>
    );
};

export default StatementDetails;
